import { useState, useEffect } from 'react';
import { useCalculate } from 'hooks/useCalculate';
import LoadingIconComponent from '../iconsComponents/LoadingIconComponent';
import { ActionButton } from 'components/MlCatalogProductList/ActionButton';
import React from 'react';

const Calculator = () => {
  const [textInput, setTextInput] = useState('');
  const [responseCalculate, setResponseCalculate] = useState('');
  // Usar el hook optimizado con TanStack Query
  const { data, isLoading, error, refetch } = useCalculate(textInput);
  
  // Estado para habilitar/deshabilitar el botón
  const asinRegex = /^B0[A-Z0-9]{8}$/;
  const isValidAsin = asinRegex.test(textInput);

  const handlerCalculate = async (e) => {
    e.preventDefault();
    if (!isValidAsin) return;
    
    try {
      await refetch();
      if (data) {
        setResponseCalculate(data);
      }
    } catch (error) {
      console.error('Error al calcular:', error);
    }
  };

  // Actualizar responseCalculate cuando data cambie
  useEffect(() => {
    if (data) {
      setResponseCalculate(data);
    }
  }, [data]);

  return (
    <>
      <div className='w-full flex space-x-4 items-center'>
        <input
          type='text'
          name='textInput'
          id='textInput'
          value={textInput}
          placeholder='Asin..'
          className='block w-[30%] rounded-md border-0 border-gray-300 py-1.5 text-gray-900 shadow ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:outline-none focus:ring-1 sm:text-sm sm:leading-6 pl-2'
          onChange={(e) => setTextInput(e.target.value)}
        />
        { isLoading && <LoadingIconComponent />}
      </div>
      {error && (
        <div className='mt-2 text-red-600'>
          Error: {error.message}
        </div>
      )}
      <div>
        {responseCalculate && (
          <div className='w-full mt-4'>
            <table className='min-w-full table-auto border border-gray-300'>
              <thead>
                <tr className='bg-gray-100'>
                  <th className='border border-gray-300 px-4 py-2 text-left'>Concepto</th>
                  <th className='border border-gray-300 px-4 py-2 text-left'>Valor</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className='border border-gray-300 px-4 py-2'>Precio Amazon</td>
                  <td className='border border-gray-300 px-4 py-2'>{Math.floor(responseCalculate.amazonPrice)}</td>
                </tr>
                <tr>
                  <td className='border border-gray-300 px-4 py-2'>Producto + envio</td>
                  <td className='border border-gray-300 px-4 py-2'>{Math.floor(responseCalculate.amazonPriceTax)}</td>
                </tr>
                <tr>
                  <td className='border border-gray-300 px-4 py-2'>Comision ml</td>
                  <td className='border border-gray-300 px-4 py-2'>{Math.floor(responseCalculate.commission)}</td>
                </tr>
                <tr>
                  <td className='border border-gray-300 px-4 py-2'>Ganancia</td>
                  <td className='border border-gray-300 px-4 py-2'>{Math.floor(responseCalculate.earnings)}</td>
                </tr>
                <tr>
                  <td className='border border-gray-300 px-4 py-2'>Giro</td>
                  <td className='border border-gray-300 px-4 py-2'>{Math.floor(responseCalculate.fee)}</td>
                </tr>
                <tr>
                  <td className='border border-gray-300 px-4 py-2'>Peso kg</td>
                  <td className='border border-gray-300 px-4 py-2'>{responseCalculate.weightKg}</td>
                </tr>
                <tr>
                  <td className='border border-gray-300 px-4 py-2'>Precio base kg</td>
                  <td className='border border-gray-300 px-4 py-2'>{Math.floor(responseCalculate.shipping)}</td>
                </tr>
                <tr>
                  <td className='border border-gray-300 px-4 py-2'>Impuesto</td>
                  <td className='border border-gray-300 px-4 py-2'>{Math.floor(responseCalculate.tax)}</td>
                </tr>
                <tr>
                  <td className='border border-gray-300 px-4 py-2'>Total</td>
                  <td className='border border-gray-300 px-4 py-2'>{Math.floor(responseCalculate.total)}</td>
                </tr>
                <tr>
                  <td className='border border-gray-300 px-4 py-2'>Total UYU</td>
                  <td className='border border-gray-300 px-4 py-2'>{Math.floor(responseCalculate.totalUYU)}</td>
                </tr>
                <tr>
                  <td className='border border-gray-300 px-4 py-2'>Total UYU redondeado</td>
                  <td className='border border-gray-300 px-4 py-2'>{Math.floor(responseCalculate.totalUYURounded)}</td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
};

export default Calculator;
